import pt from "./pt"
import en from "./en"
import es from "./es"
let messages = {
  'en': en,
  'es': es,
  'pt': pt
}
export default messages;